export default function contentParseResource({ data }) {
  return {
    id: data?.id,
    title: data?.title,
    subtitle: data?.subtitle,
    coverTitle: data?.otherTitle,
    coverSubtitle: data?.otherSubtitle,
    type: data?.type,
    slug: data?.slug,
    alias: data?.alias,
    about: data?.about,
    content: data?.content,
    seoTitle: data?.seoTitle,
    seoDesc: data?.seoDesc,
    miniCoverUrls: data?.metas.miniCoverUrls,
    coverUrls: data?.metas.coverUrls,
  };
}
